import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import qs from 'qs';
import Text from '../../atoms/Text';
import ProductWidget from './ProductWidget';
import styles from './index.pcss';
import { getCurrentStore } from '../../selectors/metaData';
import { getBannerProducts } from '../../selectors/banner';
import { getLuxeFlags } from '../../../Flags/selectors';
import {
  getProductsDetails,
  getDynamicProductsDetails,
  getCuratedProductsDetails,
  getJioAdsProducts
} from '../../../actions/bannerProducts';
import * as actions from '../../../actions/productData';
import { productDataFormatter } from '../../../utils/productWidget';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import CuratedWidget from './CuratedWidget';
import JioAdsWidget from './JioAdsWidget';
import { getCookie } from '../../../components/common/Cookie';
import RecentlyViewed from './RecentlyViewed';
import {getEnableComingSoonProducts, getPlaAdsFlags, getPlaAdsOnPDPFlag} from '../../../refresh/selectors/featureFlagsSelector';
import { getIsPriceRevealRecentlyViewed, getIsPriceRevealRecentlyViewedDuringSale, getProductCode, getRecentlyViewsDetails } from '../../selectors/productpage';
import { signInCheck } from '../../../../src/components/common/CheckUserStatus';
import { filterOutDuplicateProduct } from '../../utils/productUtils';
import { getAmplitudeExperimentVariant } from '../../../utils/amplitudeCommon';

interface ProductWidgetContainerTypes {
  banners: any;
  componentName: string | undefined;
  heading: string | undefined;
  rowNumber: Number;
  subHeading: string | undefined;
  bgColor: string | undefined;
  luxeFlags: any;
  currentStore: string;
  loadingBannerProducts: boolean;
  errorWhileLoadingData: any;
  productsData: any;
  getProductsDetails: any;
  priceRevealMetaInfoProductWidget: any;
  priceRevealMetaInfoFromPlpOnLanding: any;
  flags: any;
  deviceType: any;
  getDynamicProductsDetails: any;
  platform: string;
  dynamicProductWidgetUrl: any;
  getCuratedProductsDetails: any;
  getRecentlyViewedProductsDetails: any;
  fetchRecentlyViews: any;
  receintlyViewsDetails: any;
  isPriceRevealRecentlyViewed: any;
  isPriceRevealRecentlyViewedDuringSale: any;
  productCode: any;
  isComingSoonEnabled: boolean;
  isFromPDP: boolean;
  position: Number;
  jioAdsProducts: any;
}

interface HeadingComponentTypes {
  heading: string | undefined;
  subHeading: string | undefined;
  isDynamicProductWidget?: boolean;
  isCuratedProductWidget?: boolean;
  isLoading?: boolean;
  isAjiogram: boolean;
}
interface ProductWidgetShimmerTypes {
  luxe: boolean;
  isCuratedProductWidget?: boolean;
  isAjiogram: boolean;
}

const mapStateToProps = (state: import('../../types/rootState').RootState, ownProps) => {
  const { loading, data, error } = getBannerProducts(state);
  const rowNumber = ownProps?.rowNumber;
  const pageType = ownProps?.pageType || 'productWidget';
  const priceRevealMetaInfoFromPlpOnLanding =
    (state as { plpOnLanding?: { priceRevealMetaInfo?: unknown } })?.plpOnLanding
      ?.priceRevealMetaInfo ?? {};
  return {
    plaFlags: getPlaAdsFlags(state),
    enablePlaAdsOnPdp:  getPlaAdsOnPDPFlag(state, state?.metaData?.name),
    luxeFlags: getLuxeFlags(state.flags),
    currentStore: getCurrentStore(state),
    loadingBannerProducts: loading,
    productsData: data?.[`${pageType}${rowNumber}`],
    errorWhileLoadingData: error,
    priceRevealMetaInfoProductWidget: data?.[`priceRevealMetaInfo ${pageType}${rowNumber}`],
    flags: state.flags,
    deviceType: state?.request?.deviceType,
    dynamicProductWidgetUrl: data?.[`redirectUrl ${pageType}${rowNumber}`],
    receintlyViewsDetails: getRecentlyViewsDetails(state),
    isPriceRevealRecentlyViewed: getIsPriceRevealRecentlyViewed(state),
    isPriceRevealRecentlyViewedDuringSale: getIsPriceRevealRecentlyViewedDuringSale(state),
    productCode: getProductCode(state),
    isComingSoonEnabled: getEnableComingSoonProducts(state?.flags),
    jioAdsProducts: data?.[`jioAdsProducts${rowNumber}`],
    topJioAdProduct: data?.[`jioAdsProducts0`],
    enablePlaOnPLP: getAmplitudeExperimentVariant('enable-pla-on-plp-osmos', state),
    priceRevealMetaInfoFromPlpOnLanding
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const rowNumber = ownProps.rowNumber;
  const pageType = ownProps?.pageType || 'productWidget';


  return {
    getProductsDetails: productIds => {
      dispatch(getProductsDetails(productIds, `${pageType}${rowNumber}`));
    },
    getDynamicProductsDetails: (widgetDetails, bannerDetails, showViewAllWidget) => {
      dispatch(
        getDynamicProductsDetails(
          widgetDetails,
          bannerDetails,
          showViewAllWidget,
          `${pageType}${rowNumber}`
        )
      );
    },
    getCuratedProductsDetails: (widgetDetails, bannerDetails) => {
      dispatch(
        getCuratedProductsDetails(widgetDetails, bannerDetails, `${pageType}${rowNumber}`)
      );
    },
    getRecentlyViewedProductsDetails: (productIds: string) => dispatch(actions.getRecentlyViewed(productIds)),
    fetchRecentlyViews: (...args) => {
      import(/* webpackChunkName: "static/chunk/actions" */ '../../pages/ProductPage/actions')
        .then(module => {
          const { getRecentlyViewed } = module;
          dispatch(getRecentlyViewed(...args));
        })
        .catch(error => console.log('err', error));
    },
    getJioAdsProductsDetails: (payload, position) => {
       dispatch(getJioAdsProducts(payload,position));
    }
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

const ProductWidgetContainer = ({
  banners,
  componentName,
  heading,
  rowNumber,
  position,
  subHeading,
  bgColor,
  luxeFlags,
  currentStore,
  loadingBannerProducts,
  productsData = [],
  errorWhileLoadingData,
  getProductsDetails,
  priceRevealMetaInfoProductWidget,
  priceRevealMetaInfoFromPlpOnLanding,
  flags,
  deviceType,
  getDynamicProductsDetails,
  platform = '',
  dynamicProductWidgetUrl,
  getCuratedProductsDetails,
  getRecentlyViewedProductsDetails,
  fetchRecentlyViews,
  receintlyViewsDetails,
  isPriceRevealRecentlyViewed,
  isPriceRevealRecentlyViewedDuringSale,
  productCode,
  brickCode,
  isComingSoonEnabled,
  getJioAdsProductsDetails,
  jioAdsProducts = [],
  topJioAdProduct = [],
  isFromPDP = false,
  enablePlaAdsOnPdp,
  plaFlags: {
    isTopAdEnabled = false,
    isAdsEnabled = false,
    minNumOfProducts
  } = {},  
  isSearchPage = false,
  parentProductObj,
  enablePlaOnPLP=false
}: ProductWidgetContainerTypes): JSX.Element | null => {
  const cx = classNames.bind(styles);
  const { isThemeEnable } = luxeFlags;
  const luxe = isThemeEnable === 'ON' && currentStore === 'luxe';
  const isAjiogram = currentStore === 'ajiogram';
  const [productIdCount, setProductIdCount] = useState(0);
  const [productIdList, setProductIdList] = useState('');
  const [displayProductWidget, setDisplayProductWidget] = useState(true);
  const [shouldShowSalePrice, setShouldShowSalePrice] = useState(false);
  const [productsToDisplay, setProductsToDisplay] = useState([]);
  const productIds = banners.products;
  const [isDynamicProductList, setIsDynamicProductList] = useState(false);
  const widgetContainerRef = useRef(null);
  const hasTriggered = useRef(false);
  const { bannerType = '', ctaSettings = {}, widgetLevel = '', feedLogic = '', noOfProducts = 0 } = banners;
  const isDynamicProductWidget = bannerType === 'DYNAMIC_WIDGET';
  const isCuratedProductWidget = bannerType === 'CURATED_WIDGET';
  const isRecentlyViewedProductWidget = bannerType === 'RECENTLY_VIEWED';
  const isJioAdsWidget = bannerType === "JIO_ADS_WIDGET" || bannerType === "ADS_WIDGET";
  let recentlyViewedProductIds = [];
  if (signInCheck()) {
  const cookie = getCookie('recentlyViewed');
  if (cookie) {
    recentlyViewedProductIds = (JSON.parse(cookie) || []).map(x => x.id);
  }
}

  const productIdsWithSequence: string[] = [];
  for (const product of productIds) {
    const { productId, sequence } = product || {};
    productIdsWithSequence[sequence - 1] = productId;
  }

  useEffect(() => {
    if (productIds.length < 4 && !isDynamicProductWidget) {
      setDisplayProductWidget(false);
    }
  }, [productIds]);

  useEffect(() => {
    if (productIds.length > 0) {
      const firstProductId = productIds[0].productId;
      if (firstProductId) {
        setProductIdCount(initial => initial + 1);
      }
      const updatedProductsList = productIds.slice(1, productIds.length + 1);
      const productList = updatedProductsList.reduce((productIdList, eachProductId) => {
        setProductIdCount(initial => initial + 1);
        return `${productIdList},${eachProductId.productId}`;
      }, firstProductId);
      setProductIdList(productList);
    }
  }, [productIds]);

  useEffect(() => {
    if (productIdCount >= 4 && productIdList !== '' && productsData.length === 0) {
      getProductsDetails(productIdList);
    }
  }, [productIdCount, productIdList]);

  useEffect(() => {
    console.log('TRACK PRODUCT WIDGET CONTAINER errorWhileLoadingData', errorWhileLoadingData);
    if (errorWhileLoadingData) {
      setDisplayProductWidget(false);
    }
  }, [errorWhileLoadingData]);

  useEffect(() => {
    // NOTE: Need to check why it started failing now suddenly.
    
    if(loadingBannerProducts) return;
    if (productsData.length > 0) {
      let productsToDisplay = productsData;
      if (!isDynamicProductWidget) {
        productsToDisplay = productsToDisplay.filter((eachProduct: { inStockFlag: boolean }) => eachProduct.inStockFlag);
        if (productsToDisplay.length < 4) {
          setDisplayProductWidget(false);
          return; // Exit early to avoid further state changes
        }
      }
      const formattedProducts = productDataFormatter(productsToDisplay);
      formattedProducts.sort(
        (a: { productColor: string }, b: { productColor: string }) =>
          productIdsWithSequence.indexOf(a.productColor) -
          productIdsWithSequence.indexOf(b.productColor)
      );
      setProductsToDisplay(formattedProducts);
    }

    if (isDynamicProductWidget) {
      if (isDynamicProductList) {
        setDisplayProductWidget(productsData.length >= 4);
      } else if (productsData.length === 0) {
        setIsDynamicProductList(true);
        getDynamicProductsDetails({ heading, platform, displayRatings: isFromPDP }, banners, false);
        setDisplayProductWidget(true); // earlier this condition was true - but that is giving incorrect result for
        // condition of less than 4 - reverted this changes
      }
    }

    if (isCuratedProductWidget) {
      if (isDynamicProductList) {
        setDisplayProductWidget(productsData.length >= 4);
      } else if (productsData.length === 0) {
        setIsDynamicProductList(true);
        getCuratedProductsDetails({ heading }, banners, false);
        setDisplayProductWidget(true); // earlier this condition was true - but that is giving incorrect result for
        // condition of less than 4 - reverted this changes
      }
    }

    if (recentlyViewedProductIds.length > 0 && isRecentlyViewedProductWidget) {
      if (isDynamicProductList) {
        setDisplayProductWidget(productsData.length >= 4);
      } else if (productsData.length === 0) {
        setIsDynamicProductList(true);
        getRecentlyViewedProductsDetails(recentlyViewedProductIds.toString());
        setDisplayProductWidget(true);
      }
    }
  }, [productsData]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && isDynamicProductWidget && !hasTriggered.current) {
          gtmEventPush({
            event: 'dynamic_widget_interactions',
            event_category: 'Dynamic widget interactions',
            event_action: 'Dynamic widget view',
            event_label: `dynamic_${heading}`
          });

          hasTriggered.current = true;
          observer.disconnect(); // Optional: stop observing after first trigger
        }
      },
      {
        threshold: 0.1
      }
    );

    if (widgetContainerRef?.current) {
      observer.observe(widgetContainerRef?.current);
    }

    return () => {
      if (widgetContainerRef?.current) {
        observer.unobserve(widgetContainerRef?.current);
      }
    };
  }, [widgetContainerRef?.current]);

  useEffect(() => {
    if(isJioAdsWidget && !enablePlaOnPLP && enablePlaAdsOnPdp && isFromPDP && ((isTopAdEnabled && position === 0) || (isAdsEnabled && position != 0))){
      let  data = {productCode:productCode, brickCode: brickCode, segmentName:'', verticalName:'', asi: feedLogic, mnp:noOfProducts }
      console.log("🚀 ~ useEffect ~ jioAdsdata:", data)
      getJioAdsProductsDetails(data, position)
    }
  }, []);

  const viewShowMoreProducts = () => {
    if (dynamicProductWidgetUrl?.length > 0) {
      gtmEventPush({
        event:
          banners.widgetLevel.toLowerCase() === 'user'
            ? 'user_level_widget_interactions'
            : 'dynamic_widget_interactions',
        eventCategory:
          banners.widgetLevel.toLowerCase() === 'user'
            ? 'user_level widget interactions'
            : 'Dynamic widget interactions',
        eventAction: 'explore all click'
      });
      dynamicProductWidgetRedirection(dynamicProductWidgetUrl, true);
    }
  };

  const dynamicProductWidgetRedirection = (url = '', isViewMore = false) => {
    console.log("dynamicProductWidgetRedirection - here 326", url, isViewMore);
    if (isViewMore && url?.length > 0) {
      if (url.includes('?')) {
        url = `${url}&`;
      } else {
        const consitsSlash = url.charAt(url.length - 1) === '/';
        url = consitsSlash ? `${url}?` : `${url}/?`;
      }
      const params: any = {
        isDynamicWidget: true,
        heading,
        widgetLevel,
        feedLogic
      };
      if (banners.showDefault !== undefined) {
        params.showDefaultIfNoData = banners.showDefault;
      }
      const deeplink = `${url}${qs.stringify(params)}`;
      console.log("dynamicProductWidgetRedirection - here 344", deeplink);
      
      // iOS-compatible redirection
      if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')) {
        // iOS-specific handling using programmatic link click
        const link = document.createElement('a');
        link.href = deeplink;
        link.target = '_self';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.location.href = deeplink;
      }
    } else {
      console.log("dynamicProductWidgetRedirection - here 347", url);
      
      // iOS-compatible redirection for direct URLs
      if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')) {
        // iOS-specific handling using programmatic link click
        const link = document.createElement('a');
        link.href = url;
        link.target = '_self';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.location.href = url;
      }
    }
  };

  const eventPush = ({
    eventName,
    color,
    productName,
    selectedSizeCode,
    productCode,
    productColor,
    selectedSizeName,
    productSubCategory,
    brandName,
    discountPrice,
    ...rest
  }: Record<string, string>): void => {
    gtmEventPush({
      event: `${eventName} ${heading}`,
      page_type: 'landing page',
      product_name: productName,
      product_id: selectedSizeCode || productCode,
      product_color: color || productColor,
      product_size: selectedSizeName,
      product_catogory: productSubCategory,
      product_brand: brandName,
      product_price: discountPrice?.slice(1),
      ...rest
    });
  };

  useEffect(() => {
    const username = signInCheck();
    if (username && localStorage.getItem('priceReveal_v2')) {
      setShouldShowSalePrice(true);
    }
  }, []);

  if (
    !displayProductWidget &&
    !isCuratedProductWidget &&
    !isRecentlyViewedProductWidget &&
    !isJioAdsWidget
  ) {
    return null;
  }

  if ((productsData?.length < 4 && !isRecentlyViewedProductWidget && !isJioAdsWidget) || errorWhileLoadingData) {
    return <div />;
  }

  if (isCuratedProductWidget && (Object.keys(productsData).length === 0 ||  productsData?.curatedWidgetItemList && productsData?.curatedWidgetItemList.length === 0)){
    return null;
  }

  if (
    isFromPDP &&
    !isCuratedProductWidget &&
    !isRecentlyViewedProductWidget &&
    !productsToDisplay.length &&
    !isJioAdsWidget
  ) {
    return null;
  }

  if (enablePlaAdsOnPdp && isJioAdsWidget && isFromPDP && ((!isTopAdEnabled && position === 0) || (!isAdsEnabled && position != 0) ||(isAdsEnabled && position!=0 && jioAdsProducts?.length < minNumOfProducts))){
    return null
  }
  return (
    <div
      ref={widgetContainerRef}
      className={cx('product-widget-section', isAjiogram ? 'ajiogram' : '')}
      style={{ backgroundColor: bgColor || '#ffffff' }}
    >
      {(heading || subHeading) &&
        ((!isRecentlyViewedProductWidget && productsToDisplay?.length > 0) ||
          (isRecentlyViewedProductWidget && receintlyViewsDetails?.length > 0) ||
          (isCuratedProductWidget &&
            (productsData?.length > 0 || productsData?.curatedWidgetItemList?.length > 0)) ||
          (isJioAdsWidget && jioAdsProducts?.length > 0)) && (
          <HeadingComponent
            heading={heading}
            subHeading={subHeading}
            isDynamicProductWidget={isDynamicProductWidget}
            isCuratedProductWidget={isCuratedProductWidget}
            isLoading={loadingBannerProducts && (productsToDisplay.length === 0 || jioAdsProducts?.length === 0)}
            isAjiogram={isAjiogram}
            isJioAdsWidget={isJioAdsWidget}
            jioAdsProducts={jioAdsProducts}
          />
        )}
      {loadingBannerProducts && productsToDisplay.length === 0  && (isJioAdsWidget && position != 0) ? (
        <ProductWidgetShimmer luxe={luxe} isCuratedProductWidget={isCuratedProductWidget} />
      ) : isCuratedProductWidget ? (
        <CuratedWidget
          curatedWidgetData={productsData}
          luxe={luxe}
          rowNumber={rowNumber}
          bannerType={bannerType}
          banners={banners}
          heading={heading}
          isAjiogram={isAjiogram}
        />
      ) : isRecentlyViewedProductWidget ? (
        <RecentlyViewed
          luxe={luxe}
          products={receintlyViewsDetails}
          action={fetchRecentlyViews}
          productIds={recentlyViewedProductIds?.length > 0 ? recentlyViewedProductIds.join() : null}
          eventPush={eventPush}
          isPriceReveal={shouldShowSalePrice}
          isPriceRevealDuringSale={isPriceRevealRecentlyViewedDuringSale}
          isBottomSpace={luxe ? false : undefined}
          productCode={productCode}
          isRecentView
          isFromHomePage
          isComingSoonEnabled = {isComingSoonEnabled}
          isFleek={isAjiogram}
          priceRevealMetaInfo={priceRevealMetaInfoFromPlpOnLanding}
        />
      ) : isTopAdEnabled && jioAdsProducts?.length > 0 && isJioAdsWidget && position === 0 ? (
        <JioAdsWidget
          position={position}
          banners={banners}
          componentName={componentName}
          currentStore={currentStore}
          deviceType={deviceType}
          platform = {platform}
          isFromPDP = {isFromPDP}
          jioAdsProducts={jioAdsProducts[0]}
          feedLogic={feedLogic}
          parentProductObj={parentProductObj}
        />
      ) : (
        <ProductWidget
          products={isJioAdsWidget && isAdsEnabled && isFromPDP?  filterOutDuplicateProduct(topJioAdProduct, jioAdsProducts, 'code') : productsToDisplay}
          heading={heading}
          luxe={luxe}
          isBottomSpace={false}
          eventPush={eventPush}
          flags={flags}
          deviceType={deviceType}
          isPriceReveal={shouldShowSalePrice}
          priceRevealMetaInfoProductWidget={priceRevealMetaInfoProductWidget}
          bannerType={bannerType}
          ctaSettings={ctaSettings}
          viewShowMoreProducts={viewShowMoreProducts}
          dynamicProductWidgetRedirection={dynamicProductWidgetRedirection}
          banners={banners}
          rowNumber={rowNumber}
          isFromAjiogramLandingPage={isAjiogram}
          isFromPDP={isFromPDP}
          isSearchPage={isSearchPage}
          isJioAdsWidget = {isJioAdsWidget ? true : false}
          feedLogic={feedLogic}
          parentProductObj={parentProductObj}
          position={position}
        />
      )}
    </div>
  );
};

const HeadingComponent = ({
  heading,
  subHeading,
  isDynamicProductWidget,
  isCuratedProductWidget,
  isLoading,
  isAjiogram,
  isJioAdsWidget,
  jioAdsProducts
}: HeadingComponentTypes): JSX.Element | null => {
  const cx = classNames.bind(styles);

  if ((isCuratedProductWidget && isLoading) || (isJioAdsWidget && jioAdsProducts?.length === 0)) {
    return null;
  }

  return (
    <div className={cx('heading-container', isJioAdsWidget ? 'jioAds-heading-container' : '', isAjiogram ? 'ajiogram' : '')}>
      {heading && <Text customClass={cx('heading', isJioAdsWidget && 'jioAds-heading')} variant={isJioAdsWidget ? 'T4' :'T5'} >{heading}
        {isJioAdsWidget ? <span className={cx('ad-badge')}>AD</span> : <></>}
      </Text>}
      {subHeading && <Text customClass={cx('sub-heading')}>{subHeading}</Text>}
    </div>
  );
};

const ProductWidgetShimmer = ({
  luxe,
  isCuratedProductWidget,
  isAjiogram
}: ProductWidgetShimmerTypes): JSX.Element => {
  const cx = classNames.bind(styles);
  return (
    <div className={cx('product-widget-shimmer-container', isAjiogram ? 'ajiogram' : '')}>
      {isCuratedProductWidget && (
        <div className={cx('product-widget_header__container')}>
          <div className={cx('product_widget-header', 'ldr')} />
          <div className={cx('product_widget-sub__header', 'ldr')} />
        </div>
      )}
      <div className={cx('products-container')}>
        <div className={cx(`${luxe ? 'product-widget-card-luxe' : 'product-widget-card'}`)}>
          <div
            className={`${cx(
              `${luxe ? 'product-widget-image-shm-luxe' : 'product-widget-image-shm'}`,
              'ldr'
            )}`}
          >
            {' '}
          </div>
          <div
            className={cx(
              `${
                luxe
                  ? 'product-widget-details-container-shm-luxe'
                  : 'product-widget-details-container-shm'
              }`,
              isCuratedProductWidget ? 'curated_widget' : ''
            )}
          >
            {isCuratedProductWidget && <div className={cx('curated-widget-brand-shm', 'ldr')} />}
            {!isCuratedProductWidget && (
              <>
                <div className={`${cx('product-widget-brand-shm', 'ldr')}`}> </div>
                <div className={`${cx('product-widget-description-shm', 'ldr')}`}> </div>
                <div className={`${cx('product-widget-price-shm', 'ldr')}`}> </div>{' '}
              </>
            )}
          </div>
        </div>
        <div className={cx(`${luxe ? 'product-widget-card-luxe' : 'product-widget-card'}`)}>
          <div
            className={`${cx(
              `${luxe ? 'product-widget-image-shm-luxe' : 'product-widget-image-shm'}`,
              'ldr'
            )}`}
          >
            {' '}
          </div>
          <div
            className={cx(
              `${
                luxe
                  ? 'product-widget-details-container-shm-luxe'
                  : 'product-widget-details-container-shm'
              }`,
              isCuratedProductWidget ? 'curated_widget' : ''
            )}
          >
            {isCuratedProductWidget && <div className={cx('curated-widget-brand-shm', 'ldr')} />}
            {!isCuratedProductWidget && (
              <>
                <div className={`${cx('product-widget-brand-shm', 'ldr')}`}> </div>
                <div className={`${cx('product-widget-description-shm', 'ldr')}`}> </div>
                <div className={`${cx('product-widget-price-shm', 'ldr')}`}> </div>{' '}
              </>
            )}
          </div>
        </div>
        <div
          className={cx(`${luxe ? 'product-widget-half-card-luxe' : 'product-widget-half-card'}`)}
        >
          <div
            className={`${cx(
              `${luxe ? 'product-widget-image-shm-luxe' : 'product-widget-image-shm'}`,
              'ldr'
            )}`}
          >
            {' '}
          </div>
          <div
            className={cx(
              `${
                luxe
                  ? 'product-widget-details-container-shm-luxe'
                  : 'product-widget-details-container-shm'
              }`
            )}
          >
            {!isCuratedProductWidget && (
              <>
                <div className={`${cx('product-widget-brand-shm', 'ldr')}`}> </div>
                <div className={`${cx('product-widget-description-shm', 'ldr')}`}> </div>
                <div className={`${cx('product-widget-price-shm', 'ldr')}`}> </div>{' '}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connector(ProductWidgetContainer);
